import { render, staticRenderFns } from "./WordEditor.vue?vue&type=template&id=727028b2&"
import script from "./WordEditor.vue?vue&type=script&lang=ts&"
export * from "./WordEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports